<template>
  <div class="flex items-center gap-2">
    <OButton
      v-for="day in days"
      :key="day.id"
      pure
      class="text-white border border-white u-center h-8 sm:h-10 rounded-full hover:bg-[#6842EF]"
      :class="{ 'bg-[#6842EF] w-max px-2': day.date === selectedDay, 'w-8 sm:w-10': day.date !== selectedDay }"
      :href="getHoroscopeUrl(day.date)"
      :title="day.title"
      @click="selectedDay = day.date"
    >
      {{ day.date === selectedDay ? day.title : day.title[0] }}
    </OButton>
  </div>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { OButton } from '~/modules/common/components/ui';
import { createHoroscopeUrl, getWeekDays } from '~/modules/astrology/utils/astrologyUtils';

export default defineComponent({
  props: {
    horoscope: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    frequency: {
      type: String,
      required: true,
    },
  },
  components: {
    OButton,
  },
  setup(props) {
    const selectedDay = ref(props.date);
    const days = ref(getWeekDays(props.date));

    // get horoscope url
    const getHoroscopeUrl = (dayText) => {
      return createHoroscopeUrl({ horoscope: props.horoscope, date: dayText, frequency: props.frequency, type: props.type });
    };

    return {
      selectedDay,
      days,
      getHoroscopeUrl,
    };
  },
});
</script>
